import { render, staticRenderFns } from "./LmsFeedPost.vue?vue&type=template&id=bffebb26"
import script from "./LmsFeedPost.vue?vue&type=script&lang=js"
export * from "./LmsFeedPost.vue?vue&type=script&lang=js"
import style0 from "./LmsFeedPost.vue?vue&type=style&index=0&id=bffebb26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports